<template>
  <div class="input-wrap">
    <label v-if="label" :for="id">{{label}}</label>
    <div v-if="simple">
      <vue-editor v-model="localValue" @text-change="onTextChange"
       :editorToolbar="simpleToolbar"></vue-editor>
    </div>
    <div v-else>
      <vue-editor v-model="localValue" @text-change="onTextChange"></vue-editor>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
  name: 'RichTextInput',
  components: {
    VueEditor,
  },
  props: {
    id: String,
    value: String,
    label: String,
    simple: Boolean,
  },
  watch: {
    value(val) {
      if (val !== this.localValue) {
        this.localValue = val;
      }
    },
  },
  data() {
    return {
      localValue: this.value,
      simpleToolbar: ['bold', 'italic', 'underline', 'link'],
    };
  },
  methods: {
    onTextChange() {
      this.$emit('input', this.localValue);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/input.scss';

</style>
